var _circle, _circle2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropOffLocationMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 35,
    viewBox: "0 0 24 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 25,
    r: 10,
    fill: "#D71314",
    fillOpacity: 0.25
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 25,
    r: 6.5,
    fill: "#D71314",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7644 23.3744L11.7643 23.3744C11.4507 22.9052 11.1494 22.4548 10.86 22.022C7.86893 17.55 6.14295 14.9695 5.14981 13.148C4.60941 12.1569 4.29906 11.4131 4.12079 10.7303C3.94334 10.0506 3.89062 9.40819 3.89062 8.60869C3.89062 4.13799 7.52884 0.5 11.9993 0.5C16.4698 0.5 20.108 4.13799 20.108 8.60873C20.108 9.39921 20.0553 10.0376 19.8779 10.7161C19.6995 11.3979 19.389 12.1433 18.8485 13.1369C17.8327 15.0042 16.0501 17.6693 12.9318 22.3314C12.7064 22.6685 12.474 23.016 12.2343 23.3744C12.1818 23.4529 12.0937 23.5 11.9993 23.5C11.9049 23.5 11.8168 23.4529 11.7644 23.3744ZM7.58628 8.60869C7.58628 11.0426 9.56542 13.0217 11.9993 13.0217C14.4332 13.0217 16.4123 11.0426 16.4123 8.60869C16.4123 6.17479 14.4332 4.19566 11.9993 4.19566C9.56542 4.19566 7.58628 6.17479 7.58628 8.60869Z",
    fill: "#D71314",
    stroke: "#B91D1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropOffLocationMarker);
export default __webpack_public_path__ + "static/media/drop-off-location-marker.c92c049a2eae159371d6c56d1de43c85.svg";
export { ForwardRef as ReactComponent };